import {Box} from "@mui/material";

interface Props {
    label: string;
}

const EditSidebarTabLabel: React.FC<Props> = ({
    label
}) => {
    return (
        <Box sx={{textAlign: "center", textTransform: "none", pt: 1}}>
            <Box >{label}</Box>
        </Box>
    );
};

export default EditSidebarTabLabel;
